export default __webpack_public_path__ + "static/media/11-42.4d04eb97.jpg";